import { Component, Input, OnDestroy, ElementRef } from '@angular/core';

// Models
import { ModalID } from '../../models/constants';
// Service
import { SharedService } from '../../services/shared.service';
@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: true,
    imports: []
})
export class MessageComponent implements OnDestroy {
  message: string;
  error: boolean = false;
  error_message =
    '************************ERROR MESSAGE************************';
  html: string;

  constructor(
    protected element: ElementRef,
    public sharedService: SharedService,
  ) {

  }

  onInitialize(): void {
    // console.log(this.message, this.error, this.html);
  }

  // Closes the Modal

  closeModal(): void {
     this.sharedService.closeModal(ModalID.message);
     this.sharedService.message_viewed$.next(this.message);
  }
  ngOnDestroy() {
    //    this.sub.unsubscribe();
    }
}
